export default "__VITE_ASSET__fb42030f__"